import React, { useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import sortBy from 'lodash/sortBy';
import uniqBy from 'lodash/uniqBy';

import { makeStyles } from '@material-ui/core/styles';

import { Translate } from '@hydra/common/components';
import { CriteriumTechnologyBadge } from '@hydra/common/criterium';

import { useReviewContext } from '@hydra/common/context';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  displayToggle: {
    display: 'block',
    borderTop: '1px solid #ddd',
    color: theme.palette.primary.main,
    textAlign: 'center',
    '&:hover': {
      textDecoration: 'underline',
      backgroundColor: theme.palette.grey[100]
    }
  }
}));

export const CriteriumTechnologyList = ({ displaySize, technologies }) => {
  const { isPdf } = useReviewContext();
  const classes = useStyles();
  const filteredTechnologies = useMemo(() => uniqBy(sortBy(technologies, ['id']), t => t.id), [technologies]);
  const [displayAll, setDisplayAll] = useState(false);

  const handleToggleDisplayClick = useCallback((event) => {
    event.stopPropagation();

    setDisplayAll(displayAll => !displayAll);
  }, []);

  return (
    <>
      <div className={classes.root}>
        {
          filteredTechnologies
            .slice(0, displayAll ? filteredTechnologies.length : displaySize)
            .map(technology => (
              <CriteriumTechnologyBadge
                key={technology.id}
                id={technology.id}
                app={technology.app}
              />
            ))
          }
      </div>
      {filteredTechnologies.length > displaySize && (
        isPdf
          ? <Translate content='pdf_and_more' with={{ count: filteredTechnologies.length - displaySize }} />
          : (
            <a className={classes.displayToggle} onClick={handleToggleDisplayClick}>
              {displayAll && <Translate content='view_less_data' />}
              {!displayAll && <Translate content='show_more' />}
            </a>
            )
      )}
    </>
  );
};

CriteriumTechnologyList.propTypes = {
  displaySize: PropTypes.number,
  technologies: PropTypes.array
};

CriteriumTechnologyList.defaultProps = {
  displaySize: 20
};

export default CriteriumTechnologyList;
